import styled from 'styled-components';

const Meta = styled.ul`
  display: flex;
  list-style-type: none;
`;

export default Meta;
